module.exports = __webpack_public_path__ + "img/highlighting-purple.8154d470.svg";